import gql from 'graphql-tag';

const GET_MAILBOXES = gql`
  query getMailboxes($isClientMailbox: Boolean!, $isMSPProduct: Boolean!) {
    getMailboxes {
      boxId
      type
      systemBox
      incomingAddress
      outgoingAddress
      customServer
      customServerType
      customServerOutgoingOnly
      imapHost
      userName
      customServerAuthenticationRequired
      imapPort
      smtpHost
      smtpPort
      sslRequired
      customServerAccountSyncState
      outgoingAddressType # OutgoingAddressType
      senderConfiguration {
        verificationRecords {
          recordType
          host
          value
        }
      }
      outgoingDomainVerified
      onBehalfOf
      senderName
      emailSignature
      client @include(if: $isMSPProduct) {
        accountId
        name
      }
      site @include(if: $isClientMailbox) {
        id
        name
      }
      techGroup @include(if: $isClientMailbox) {
        groupId
        name
      }
      hasAdvancedConfiguration @include(if: $isClientMailbox)
      defaultBox @include(if: $isClientMailbox)
      name @include(if: $isClientMailbox)
      description @include(if: $isClientMailbox)
      customServerAuthenticationRequired
    }
  }
`;

const GET_MAILBOX_FORWARDING_ADDRESS = gql`
  query getMailboxForwardingAddress($input: String!) {
    getMailboxForwardingAddress(input: $input)
  }
`;

const GET_MAIL_PROVIDER_CONFIGS = gql`
  query getMailProviderConfigs($boxId: ID!) {
    getMailProviderConfigs(boxId: $boxId) {
      providerConfigId
      boxId
      customServerType
      customServerProvider
      customServerAccountSyncState
      priority
    }
  }
`;

const GET_MAILBOX_ENABLED_STATUS = gql`
  query getMailboxEnabledStatus($type: MailSettingsType!) {
    getMailboxEnabledStatus(type: $type)
  }
`;

export {
  GET_MAILBOXES,
  GET_MAILBOX_FORWARDING_ADDRESS,
  GET_MAIL_PROVIDER_CONFIGS,
  GET_MAILBOX_ENABLED_STATUS
};
